import React from "react";
import {useState, useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import { PuffLoader } from "react-spinners";
import PageHome from './PageHome'
import PageSluzby from './PageSluzby'
import PageKontakt from './PageKontakt'
import PageProjekty from './PageProjekty'
import PageCertifikaty from './PageCertifikaty'
import PageProjektyBody7 from './PageProjektyBody7'
import PageProjektyBody8 from './PageProjektyBody8'
import PageProjektyBody9 from './PageProjektyBody9'
import PageProjektyBody10 from './PageProjektyBody10'
import PageProjektyBody11 from './PageProjektyBody11'
import PageProjektyBody13 from './PageProjektyBody13'
import PageProjektyBody14 from './PageProjektyBody14'
import PageProjektyBody15 from './PageProjektyBody15'
import PageProjektyBody16 from './PageProjektyBody16'
import PageProjektyBody17 from './PageProjektyBody17'
import PageProjektyBody18 from './PageProjektyBody18'
import PageProjektyBody19 from './PageProjektyBody19'
import PageProjektyBody20 from './PageProjektyBody20'
import PageProjektyBody21 from './PageProjektyBody21'
import PageProjektyBody22 from './PageProjektyBody22'
import PageProjektyBody23 from './PageProjektyBody23'
import './App.css';

function App() {

  const [loading, setLoading] = useState(false)

  useEffect(()=>{
    setLoading(true) 
    setTimeout(()=>{
    setLoading(false)
    },3000)},[])


  return (

    <div className="loader">
    {loading ? (
      <PuffLoader  size={150} 
                   color="#00AA4A" 
                   loading={loading}/>
      ) : (

    <div className="app">

<Router>
 <Routes>
  <Route path="/" element={<PageHome/>}/>
  <Route path="/PageKontakt" element={<PageKontakt/>}/>
  <Route path="/PageSluzby" element={<PageSluzby/>}/>
  <Route path="/PageProjekty" element={<PageProjekty/>}/>
  <Route path="/PageCertifikaty" element={<PageCertifikaty/>}/>
  <Route path="/PageProjektyBody7" element={<PageProjektyBody7/>}/>
  <Route path="/PageProjektyBody8" element={<PageProjektyBody8/>}/>
  <Route path="/PageProjektyBody9" element={<PageProjektyBody9/>}/>
  <Route path="/PageProjektyBody10" element={<PageProjektyBody10/>}/>
  <Route path="/PageProjektyBody11" element={<PageProjektyBody11/>}/>
  <Route path="/PageProjektyBody13" element={<PageProjektyBody13/>}/>
  <Route path="/PageProjektyBody14" element={<PageProjektyBody14/>}/>
  <Route path="/PageProjektyBody15" element={<PageProjektyBody15/>}/>
  <Route path="/PageProjektyBody16" element={<PageProjektyBody16/>}/>
  <Route path="/PageProjektyBody17" element={<PageProjektyBody17/>}/>
  <Route path="/PageProjektyBody18" element={<PageProjektyBody18/>}/>
  <Route path="/PageProjektyBody19" element={<PageProjektyBody19/>}/>
  <Route path="/PageProjektyBody20" element={<PageProjektyBody20/>}/>
  <Route path="/PageProjektyBody21" element={<PageProjektyBody21/>}/>
  <Route path="/PageProjektyBody22" element={<PageProjektyBody22/>}/>
  <Route path="/PageProjektyBody23" element={<PageProjektyBody23/>}/>
 </Routes>
</Router>

    </div>
     )}
     </div>
  );
}

export default App;
